import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import EditSurgeryFormModal from './SurgeryFormModal';
import { EditOutlined } from '@ant-design/icons';

const EditCatalogLabTestButton = (
  {
    columnData, onUpdateSurgery, getMedicalCatalogSurgeryInfo, infoTestLog,
  },
) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [formData, setFormData] = useState({});

  const showModal = async () => {
    await getMedicalCatalogSurgeryInfo(columnData.id);
    setModalVisible(true);
  };
  const hideModal = () => {
    setModalVisible(false);
  };
  const onSubmit = async (data) => {
    const payloadObj = {
      id: columnData.id,
      payload: { surgery_package: data },
    };
    await onUpdateSurgery(payloadObj);
    hideModal();
  };

  useEffect(() => {
    setFormData(infoTestLog);
  }, [modalVisible]);

  return (
    <>
      <EditSurgeryFormModal
        data={formData}
        onSubmit={onSubmit}
        onCancel={hideModal}
        visible={modalVisible}
        width={1000}
        title="Edit Surgery Package"
        submitText="Update Surgery Package"
      />
      <div onClick={showModal}><EditOutlined /></div>
    </>
  );
};

const mapStateToProps = ({ medicalReducer }) => ({
  infoTestLog: medicalReducer.result,
});

export default connect(mapStateToProps)(EditCatalogLabTestButton);
